var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.43918 0.43918C0.157973 0.720471 0 1.10193 0 1.49968C0 1.89743 0.157973 2.27889 0.43918 2.56018L7.86418 9.98518L0.43918 17.4102C0.165943 17.6931 0.0147506 18.072 0.0181682 18.4653C0.0215858 18.8586 0.17934 19.2348 0.457452 19.5129C0.735564 19.791 1.11178 19.9488 1.50508 19.9522C1.89837 19.9556 2.27728 19.8044 2.56018 19.5312L11.0457 11.0457C11.3269 10.7644 11.4849 10.3829 11.4849 9.98518C11.4849 9.58743 11.3269 9.20597 11.0457 8.92468L2.56018 0.43918C2.27889 0.157973 1.89743 0 1.49968 0C1.10193 0 0.720472 0.157973 0.43918 0.43918Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.e8ecc7f9b6ad2299bbaa082f4f6fd44f.svg";
export { ForwardRef as ReactComponent };